import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CForm,
	CFormInput,CInputGroup,CInputGroupText,
	CButton,
	CImage,
	CSpinner,CBadge,
	CCard,CCardHeader,CCardFooter,CCardBody,
} from '@coreui/react';
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import CIcon from '@coreui/icons-react';
import {
	MyDialogform,
	MyPagination,
	MyPage500,
	MyButton,
} from '../components/index'
import { UFunc } from '../helpers/functions'
import { Konfirm } from '../helpers/onConfirm';

const pjson 	= require('../../package.json')
const Tutupperiode= (props) => {
	const {
		setToken,setLoading,showToast,prosesExpired,setSessionaktif,clearStorage
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uBahasaObj  			= useSelector(state => state.listBahasa);
	const uActiveroute  		= useSelector(state => state.activeRoute);
	const uEfekapp				= useSelector(state => state.effectApp);
	const uIsScrollBottom		= useSelector(state => state.gIsScrollBottom);
	const uUserSettingObj 		= useSelector(state => state.gListUserSetting);
	const uSettingsystemObj		= useSelector(state => state.gSystemsetting);
	const [uEfekview,setEfekview]= React.useState(false);
	const uIsEOMExecuted		= useSelector(state => state.gIsEOMExecuted);
	const uEOMLabel				= useSelector((state) => state.gEOMLabel) || "";
	
	const uIsAllowedhapus		= uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN"
	const uMaxData				= isMobile ? (uUserSettingObj.jml_mobile || 30) : (uUserSettingObj.jml_laporan || 100);
	const uKeywordObj			= JSON.parse(localStorage.getItem("listkeyword")) || {};

	const uHeaderactionObj  	= useSelector(state => state.gInitHeaderAction);
	const uHandelView 			= uHeaderactionObj.isHeaderView || false;

	//const uHeaderTutupperiode 	= uHeaderactionObj.isHeaderTutupperiode || false;
	//const uHeaderBroken 		= uHeaderactionObj.isHeaderBroken || false;

	/*//---PAGINATION_DIATUR_BACKEND--/
	const uTabelSelectObj 	= useSelector(state => state.gInitTabelSelected);
	const uIsInitbefore 	= (JSON.stringify(uTabelSelectObj||{})!=="{}");
	const [uInitbeforeprocess,setInitbeforeprocess] = React.useState(false);
	//---END PAGINATION_DIATUR_BACKEND--*/

	const [uHTMLError500,setHTMLError500]	= React.useState();
	const [uFirstload,setFirstload]			= React.useState("YA");
	const [uDatamainObj,setDatamainObj]		= React.useState({});
	const [uISLoadingview,setLoadingview]	= React.useState(false);
	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);
	const [uISProcessingtutup,setProcessingtutup]= React.useState(false);
	const [connectionType, setConnectionType] = React.useState("");
	const [uProcessingprogress,setProcessingprogress]= React.useState("");

	//--DLG_FORM--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformObj,setDlgformObj]		= React.useState({});
	//--END DLG_FORM--/

	//---DOM--/
	const uTanggalNowDT						= new Date();
	/*const uElCardlast	= document.getElementById("idcardlast")
	const uElCardnext	= document.getElementById("idcardnext")
	const uElCardlastHeight	= uElCardlast && (uElCardlast.offsetHeight);
	const uElCardnextHeight	= uElCardnext && (uElCardnext.offsetHeight);
	//---END DOM--*/

	//---HANDLE--/
	const hdlKlikProseseod = async() => {
		if(await Konfirm(
			"<p><b>PROSES End-Of-Day (EOD)</b>..</p>"+
			"<p>EOD akan memproses Jurnal Transaksi setiap harinya.</p>"+
			"<p class='fst-italic mx-2 classfontsmaller'><b>PERHATIAN:</b>"+
			"<ul>"+
			"<li class='fst-italic'>Proses EOD kemungkinan Akan Berlangsung LAMA, Mohon JANGAN TUTUP BROWSER Sebelum Proses Benar-benar Selesai.</li>"+
			"<li class='fst-italic'>Proses Ini tidak dapat dibatalkan.</li>"+
			"</ul>"+
			"</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) apiProsesEOD();
	}
	const hdlKlikProses = async() => {
		//apiProsesEOY(); return;//--BUAT_TESTING--/
		if((uDatamainObj.jenis_nexttutup||"").toUpperCase() === "TAHUN") {
			uDlgformObj.dlg_header 		= "Proses End-Of-Year";
			uDlgformObj.nilai_pph2529	= parseFloat(uDatamainObj.nilai_pph2529) ||0;
			setDlgformshow(true);
			return;
		}
		const vTglnowDB	= UFunc.DbDate();
		const vTglnowDT	= UFunc.toDate(vTglnowDB);
		const vTglnexttutupDT	= UFunc.toDate(uDatamainObj.tgl_nexttutup);
		//const vTglnexttutupDT	= UFunc.toDate("2025-04-30");//--TEST
		//--CEK_JIKA_TGL_EOM_BELUM_TERCAPAI--/
		if(vTglnowDT.valueOf() < vTglnexttutupDT.valueOf()) {
			showToast("<p class='fw-bolder'>Tanggal Tutup Periode Belum Tercapai..</p>"+
				"<p>Tanggal Tutup Periode Selanjutnya Harus <b>Sudah Terlewati</b>,</p>"+
				"<p>Atau Hari Ini Merupakan Tanggal <b>TERAKHIR Bulan</b> Tersebut..</p>"+
				"");
			return;
		}
		//--END CEK_JIKA_TGL_EOM_BELUM_TERCAPAI--*/

		const vFunctionnext = () => {
			//--JIKA_TGLTUTUP_SMDENGAN_TGLNOW--/
			if(vTglnowDB === uDatamainObj.tgl_nexttutup) {
				apiProsesEOMSekuensial();
				return;
			}

			apiProsesEOM();
		}

		if(await Konfirm(
			"<p><b>PROSES Tutup Periode End-Of-Month (EOM)</b>..</p>"+
			"<p>EOM akan memproses Biaya Penyusutan per Bulan dan "+
				"menghitung Laba/Rugi Periode Tersebut.</p>"+
			"<p class='fst-italic mx-2 classfontsmaller'><b>PERHATIAN:</b>"+
			"<ul>"+
			"<li class='fst-italic'>Proses EOM kemungkinan Akan Berlangsung LAMA, Mohon JANGAN TUTUP BROWSER Sebelum Proses Benar-benar Selesai.</li>"+
			"<li class='fst-italic'>Proses Ini tidak dapat diulang dan dibatalkan.</li>"+
			"</ul>"+
			"</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) vFunctionnext();
	}
	const hdlKlikDlgformsimpan = async() => {
		const vNilairiilPPH		= parseFloat(uDlgformObj.nilai_pph2529)||0;
		const vNilaiasumsiPPH	= parseFloat(uDatamainObj.nilai_pph2529)||0;

		if(vNilairiilPPH < 0) {
			showToast("<b>Invalid Nilai Pph !</b>"); return;
		}

		if(vNilairiilPPH === 0 || vNilairiilPPH !== vNilaiasumsiPPH) {
			if(await Konfirm(
				"<b>Anda Memasukkan Nilai PPh Ps.25/29: <span class='text-danger'>Rp"+UFunc.formatAngka(uDlgformObj.nilai_pph2529)+"</span></b>.."+
				(vNilairiilPPH !== vNilaiasumsiPPH ? "<br/><br/>Estimasi PPh Ps.25/29: <b>Rp"+UFunc.formatAngka(uDatamainObj.nilai_pph2529)+"</b>" : "")+
				"<br/>PERHATIAN: <b>Proses Ini tidak dapat dibatalkan dan diulang !</b>"+

				"<br/><br/>Apakah Yakin TETAP AKAN MEMPROSES ?"+
				"")) apiProsesEOY();
			return;
		}

		apiProsesEOY();
	}
	const hdlKlikProsesstatus = async() => {
		if(await Konfirm(
			"<b>PROSES Pembatalan Status PROSES..</b>"+
			"<br/>Status DALAM PROSES Tutup Perode Akan Dibatalkan, agar Input Transaksi Dapat Dilakukan Kembali."+
			"<br/><br/>Apakah Anda Yakin ?"+
			"")) apiProsesbatalstatus();
	}
	const handleBeforeUnload = (event) => {
		event.preventDefault();
		
		const vMessage = 
		"Tutup Periode Sedang Dalam Proses.."+
		"<br/>JANGAN TUTUP BROWSER ANDA !!"+
		"";
		
		event.returnValue = vMessage;
		return vMessage;
	};
	//---END HANDLE--/

	//---PROSES--/
	//---END PROSES--/

	//---CONTENT--/
	const contentData = () => {
		if(uHTMLError500) return ""

		if(uISLoadingview) return (
			<div align="center" className="mt-5"><CSpinner color="primary" className="mx-auto"/></div>
		)//>

		return (
		<>
		<CRow className="mx-0">
			<CCol xs="6"><small>Tutup Periode Terakhir</small></CCol>
			<CCol xs="6" className="fw-bolder text-end">{UFunc.TglAngka(uDatamainObj.tgl_lasttutup)}</CCol>

			<div className="mt-3"/>

			<CCol xs="6"><small>Jenis Tutup Periode</small></CCol>
			<CCol xs="6" className="fw-bolder text-end text-primary">{uDatamainObj.caption_lasttutup || "END OF MONTH"}</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<div className="classpetunjuk px-0">
		<b>CATATAN</b>:
		<ol className="ps-3">
		<li>Tutup Periode terdiri dari 3 Proses. Yaitu, <b>End-Of-Days (EOD)</b>, <b>End-Of-Month (EOM)</b>, dan <b>End-Of-Year</b>.</li>
		<li className="mt-2"><b>EOD</b> Dilakukan setiap Akhir Hari, untuk memproses JURNAL AKUNTANSI Transaksi selama SATU Hari. Proses Ini tidak WAJIB dilakukan secara MANUAL, karena Sistem akan Memprosesnya Setiap Akhir Hari secara otomatis.</li>
		<li className="mt-2"><b>EOM</b> Harus Dilakukan Secara MANUAL pada Tanggal Akhir setiap Bulannya. 
			Proses Ini dilakukan untuk memproses JURNAL Penyusutan Aset per Bulan.</li>
		<li className="mt-2"><b>EOY</b> Harus Dilakukan Secara MANUAL pada Tanggal Akhir setiap Tahunnya. 
			Proses Ini dilakukan untuk mengakhiri Proses Pembukuan Tiap Tahun.</li>
		<li className="mt-2"><b>NOTE</b>: Terkadang Proses Tutup Perode <b>Tidak BERHASIL</b> selesai dengan SEMPURNA, dan Status Prosesnya <b>TETAP DALAM PROSES</b>.
			<br/>Jika Demikian, Silahkan KLIK Tombol <b>BATALKAN STATUS EOM</b>, agar Proses Input Transaksi Dapat Dilakukan Kembali.</li>
		</ol>
		</div>
		</>
		)//>
	}
	const contentFormeod = () => {
		if(uHTMLError500) return ""

		if(uISLoadingview) return (
			<center><CSpinner color="primary" className="mx-auto"/></center>
		)//>

		return (
		<>
		<div className="d-flex justify-content-between px-3">
			<div><small>Tgl EOD Terakhir</small></div>
			<div className="text-end fw-bolder classfontsmaller text-primary">
			{!UFunc.isEmpty(uSettingsystemObj.tgl_last_eod) 
				? UFunc.HariAngka(uSettingsystemObj.tgl_last_eod)+" "+UFunc.JamMenitDetik(uSettingsystemObj.tgl_last_eod) 
				: "-" }
			</div>
		</div>

		{(uTokenObj.userhak === "FREEROLE" && (uDatamainObj.eom_is_running||"TIDAK")==="YA") && (
		<>
			<div className="my-3 classborderbottom"/>
			<div className="d-flex justify-content-between px-3">
				<div className="text-danger"><small>Reactivate Proses EOD/EOM/EOY</small></div>
				<div className="text-end fw-bolder">
				<CButton size="sm" color="danger" className="text-white"
					onClick={()=>hdlKlikProsesstatus()}
					id="btnBatalflageom">
					<small>Batalkan Status EOM</small>
				</CButton>
				</div>
			</div>
		</>
		)}

		<div className="my-3 classborderbottom"/>

		<div className="d-none">{(connectionType)}</div>

		{(uTokenObj.userhak === "FREEROLE") ? (
		<CForm className="text-center">
			<MyButton
				onClick={()=>hdlKlikProseseod()}
				disabled={!uIsEOMExecuted || (uDatamainObj.eom_is_running||"TIDAK")==="YA"}
				id="btnProsesEOD">
				Proses EOD
			</MyButton>
		</CForm>
		) : (
		<div className="text-center fst-italic p-md-3 px-md-5 text-danger">
			Jenis User Anda, Tidak Diperbolehkan Melakukan Proses End-Of-Days (EOD)
		</div>
		)}
		</>
		)//>
	}
	const contentFormtutup = () => {
		if(uHTMLError500) return ""

		if(uISLoadingview) return (
			<center><CSpinner color="primary" className="mx-auto"/></center>
		)//>

		const vISDisabledEOM = ((uEOMLabel !== "") 
				&& (uEOMLabel.toUpperCase()!=="EOM WARNING")
				&& ((uDatamainObj.caption_nexttutup||"").toUpperCase() === "END OF MONTH"))
			 || (uDatamainObj.eom_is_running||"TIDAK")==="YA";

		return (
		<>
		<div className="d-none my-3 classborderbottom">{JSON.stringify(uDatamainObj)}</div>

		<CRow className="mx-0">
			<CCol xs="6"><small>Tgl Tutup Next</small></CCol>
			<CCol xs="6" className="text-end fw-bolder">{UFunc.HariAngka(uDatamainObj.tgl_nexttutup)}</CCol>
			
			<div className="mt-3"/>

			<CCol xs="6"><small>Jenis Tutup Next</small></CCol>
			<CCol xs="6" className="text-end fw-bolder">{uDatamainObj.caption_nexttutup||"END OF MONTH"}</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		{uTokenObj.userhak === "FREEROLE" ? (
		<CForm className="text-center">
			<MyButton
				onClick={()=>hdlKlikProses()}
				disabled={vISDisabledEOM}
				id="btnProses">
				Proses Tutup
			</MyButton>
		</CForm>
		) : (
		<div className="text-center fst-italic fw-bolder p-md-3 px-md-5 text-danger">
			Jenis User Anda, Tidak Diperbolehkan Melakukan TUTUP PERIODE
		</div>
		)}
		</>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		return (
		<CForm>
		<CRow className="my-2">
			<CCol xs="6">Estimasi PPh Ps.25/29</CCol>
			<CCol className="text-end">
				<b className="text-danger">Rp {UFunc.formatAngka(uDatamainObj.nilai_pph2529)}</b>
			</CCol>
		</CRow>
		
		<div className="my-4 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="6">Nilai RIIL PPh Ps.25/29</CCol>
			<CCol className="text-end">
				<NumberFormat 
					value={uDlgformObj.nilai_pph2529}
					displayType={'text'} 
					thousandSeparator={"."} 
					decimalSeparator={","}
					allowNegative={false}
					allowDecimal={true}
					onValueChange={(values) => uDlgformObj.nilai_pph2529 = values.value}
					renderText={values => (
						<CFormInput size="sm" 
							value={values}
							onChange={(e) => setDlgformObj({...uDlgformObj,nilai_pph2529: e.target.value})}
							onFocus={(e) => e.target.select()}
							onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
							className="text-end"
							id="inpnilaipph2529"/>
					)} 
				prefix={isMobile?"":"Rp"}/>
			</CCol>
		</CRow>
		</CForm>
		)//->
	}
	//---END CONTENT--/

	//---API--/
	const apiLoaddata = () => {
		setHTMLError500();
		setDatamainObj({});
		setLoadingview(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoadingview(false);
			setLoading(false);
		},2500); return;
		//--END TESTING_FRONTEND--*/

    	const connectionType = navigator.connection ? navigator.connection.effectiveType : "";

		const vDATAS	= JSON.stringify({
			send_connectiontype: connectionType,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_tutupperiode/ld_data";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			setLoadingview(false);
			setLoading(false);
			//console.log("(Tutupperiode - apiLoaddata) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				const vTmpObj	= JSON.parse(output_string.dataobject || "{}");
				//vTmpObj.eom_is_running = "YA";//--TESTING--/
				setDatamainObj(vTmpObj);

				//setConnectionType(output_string.connectiontype || "UNKNOWN");
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("(Tutupperiode - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoadingview(false);
			setLoading(false);
			console.log("(Tutupperiode - apiLoaddata) catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsesEOD = () => {
		const vArrprocess	= [
			{ caption_target:"Proses Tahap 1", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_tahap1" },
			{ caption_target:"Proses Tahap 2", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_tahap2" },
			{ caption_target:"Proses Pembelian", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_pembelian" },
			{ caption_target:"Proses Aset", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_aset" },
			{ caption_target:"Proses Pendapatan", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_pendapatan" },
			{ caption_target:"Proses Piutang", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_piutang" },
			//{ caption_target:"Proses Payroll", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_payroll" },
			{ caption_target:"Proses Akhir", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_last" },
		];

		const vDATAS	= JSON.stringify({
			send_parsdata : JSON.stringify(uDatamainObj),
			send_tokenauth : uTokenObj.userinit
		});

		const reprocessApi = async(_OBJPROSES) => {
			const vProses = _OBJPROSES || {};
			try {
				setSessionaktif(true);
				const response = await fetch(vProses.url_target, {
					headers: { Accept: "application/json", "Content-Type": "application/json" },
					method: "POST", mode: "cors",
					cache: "default",
					body: vDATAS,
				});

				console.log(`(Tutupperiode - apiProsesEOD) reprocessApi ${vProses.caption_target} == ${UFunc.JamMenitDetik()}`)
				if (!response.ok) {
					throw new Error(`Failed to execute task at ${vProses.caption_target}`);
				}

				setSessionaktif(false);
				const output_string = await response.json();
				if (output_string.errors) {
					throw new Error(`${vProses.caption_target} [ERRORS]: ${output_string.errors}`);
				}
				if (output_string.info) {
					throw new Error(`${vProses.caption_target} [INFO]: ${output_string.info}`);
				}
				if(output_string.expired) {
					prosesExpired();
					throw new Error("{EXPIRED SESSION}");
				}

				if(output_string.reprocess) {
					const resultreprocess = await reprocessApi(vProses);
				}
			} catch (err) {
				console.log(`(Tutupperiode - apiProsesEOD) reprocessApi CATCH ${vProses.caption_target}: ${err.message} == ${UFunc.JamMenitDetik()}`);
				throw err;
			}
		}

		const processSequentially = async(_ARRPROSES) => {
			let vArrResults = [];

			for (const vProses of _ARRPROSES) {
				try {
					setSessionaktif(false);
					setProcessingprogress(vProses.caption_target);
					const response = await fetch(vProses.url_target, {
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});

					console.log(`(Tutupperiode - apiProsesEOD) processSequentially ${vProses.caption_target} == ${UFunc.JamMenitDetik()}`)
					if (!response.ok) {
						throw new Error(`Failed to execute task at ${vProses.caption_target}`);
					}

					setSessionaktif(true);
					const output_string = await response.json();
					if (output_string.errors) {
						throw new Error(`${vProses.caption_target} [ERRORS]: ${output_string.errors}`);
					}
					if (output_string.info) {
						throw new Error(`${vProses.caption_target} [INFO]: ${output_string.info}`);
					}
					if(output_string.expired) {
						prosesExpired();
						throw new Error("{EXPIRED SESSION}");
					}

					vArrResults.push(output_string.sukses);
					if(output_string.reprocess) {
						const resultreprocess = await reprocessApi(vProses);
					}
				} catch (err) {
					console.log(`(Tutupperiode - apiProsesEOD) processSequentially CATCH ${vProses.caption_target}: ${err.message} == ${UFunc.JamMenitDetik()}`);
			        throw err;
				}
			}
			return vArrResults;
		}

		(async () => {
			let vArrResults = [];
			const vElbuttoneod 	= document.getElementById("btnProsesEOD");
			const vElbutton 	= document.getElementById("btnProses");

			vElbutton && (vElbutton.disabled = true);
			vElbuttoneod && (vElbuttoneod.disabled = true);
			setProcessingtutup(true);
			setLoading(true);
			try {
				setProcessingprogress("Preparing");
				console.log(`(Tutupperiode - apiProsesEOD) TRY ${UFunc.JamMenitDetik()}`);
				//--PREPARING--/
				setSessionaktif(false);
				const response = await fetch(pjson.homepage+"api/api_tutupperiode/pr_eod_preparing", {
					headers: { Accept: "application/json", "Content-Type": "application/json" },
					method: "POST", mode: "cors",
					cache: "default",
					body: vDATAS,
				});
				const output_string = await response.json();
				setSessionaktif(true);
				if (output_string.errors) {
					throw new Error(`Preparing Proses [ERRORS]: ${output_string.errors}`);
				}
				if (output_string.info) {
					throw new Error(`Preparing Proses [INFO]: ${output_string.info}`);
				}
				if(output_string.expired) {
					prosesExpired();
					throw new Error("{EXPIRED SESSION}");
				}
				//--END PREPARING--/
				
				try {
					const results = await processSequentially(vArrprocess);
					vArrResults.push(...results);
				} finally {
					setProcessingprogress("Finishing");
					const response = await fetch(pjson.homepage+"api/api_tutupperiode/pr_finishing", {
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});
					const output_string = await response.json();//-*/
					/*//--SEMENTARA_TEST--/
					console.log(`(Tutupperiode - apiProsesEOD) FINALLY ${vArrResults.length} === ${vArrprocess.length}`);
					console.log(`(Tutupperiode - apiProsesEOD) FINALLY ${JSON.stringify(vArrResults)} === ${vArrprocess.length}`);

					if (output_string.errors) {
						showToast(output_string.errors || 'Custom Error from Server',"ERROR");
						return;
					}
					if (output_string.info) {
						showToast(output_string.info || 'Custom INFO from Server',"ERROR");
						return;
					}
					if(output_string.expired) {
						prosesExpired();
						return;
					}
					//--END SEMENTARA_TEST--*/

					uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||JSON.stringify(uSettingsystemObj))});
				}
			} catch (err) {
				//showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
				console.log(`(Tutupperiode - apiProsesEOD) CATCH ${err.message} ${UFunc.JamMenitDetik()}`)
				showToast(err.message || 'An unexpected error occurred',"ERROR");
			} finally {
				setProcessingprogress("");
				vElbutton && (vElbutton.disabled = false);
				vElbuttoneod && (vElbuttoneod.disabled = false);

				console.log(`(Tutupperiode - apiProsesEOD) FINALLY ${UFunc.JamMenitDetik()}`)
				setLoading(false);
				setProcessingtutup(false);

				if(vArrResults.length === vArrprocess.length) {
					showToast("<b>BERHASIL</b> !"+
						"<br/>Proses EOD Telah Selesai."+
						"<br/><br/>Mohon Logout dan Login Kembali, dan <b>Silahkan Lanjutkan Aktifitas Selanjutnya</b>.."+
						"","SUKSES");
			    	clearStorage(); setToken("");//--KALO_TEST_DITUTUP--/
				}
			}
		})();
	}
	const apiProsesEOMSekuensial = () => {
		const vArrprocess	= [
			{ caption_target:"Proses Tahap 1", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_tahap1" },
			{ caption_target:"Proses Tahap 2", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_tahap2" },
			{ caption_target:"Proses Pembelian", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_pembelian" },
			{ caption_target:"Proses Aset", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_aset" },
			{ caption_target:"Proses Pendapatan", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_pendapatan" },
			{ caption_target:"Proses Piutang", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_piutang" },
			{ caption_target:"Proses Akhir", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_last" },
			{ caption_target:"Proses Payroll", url_target:pjson.homepage+"api/api_tutupperiode/pr_eod_payroll" },
			{ caption_target:"Proses Penyusutan", url_target:pjson.homepage+"api/api_tutupperiode/pr_eom_penyusutan" },
			{ caption_target:"Proses AdjustmentHPP", url_target:pjson.homepage+"api/api_tutupperiode/pr_eom_adjustmenthpp" },
			{ caption_target:"Proses EOM", url_target:pjson.homepage+"api/api_tutupperiode/pr_tutup_eom" },
		];

		const vDATAS	= JSON.stringify({
			send_parsdata : JSON.stringify(uDatamainObj),
			send_tokenauth : uTokenObj.userinit
		});

		const reprocessApi = async(_OBJPROSES) => {
			const vProses = _OBJPROSES || {};
			try {
				setSessionaktif(true);
				const response = await fetch(vProses.url_target, {
					headers: { Accept: "application/json", "Content-Type": "application/json" },
					method: "POST", mode: "cors",
					cache: "default",
					body: vDATAS,
				});

				console.log(`(Tutupperiode - apiProsesEOMSekuensial) reprocessApi ${vProses.caption_target} == ${UFunc.JamMenitDetik()}`)
				if (!response.ok) {
					throw new Error(`Failed to execute task at ${vProses.caption_target}`);
				}

				setSessionaktif(false);
				const output_string = await response.json();
				if (output_string.errors) {
					throw new Error(`${vProses.caption_target} [ERRORS]: ${output_string.errors}`);
				}
				if (output_string.info) {
					throw new Error(`${vProses.caption_target} [INFO]: ${output_string.info}`);
				}
				if(output_string.expired) {
					prosesExpired();
					throw new Error("{EXPIRED SESSION}");
				}

				if(output_string.reprocess) {
					const resultreprocess = await reprocessApi(vProses);
				}
			} catch (err) {
				console.log(`(Tutupperiode - apiProsesEOMSekuensial) reprocessApi CATCH ${vProses.caption_target}: ${err.message} == ${UFunc.JamMenitDetik()}`);
				throw err;
			}
		}

		const processSequentially = async(_ARRPROSES) => {
			let vArrResults = [];

			for (const vProses of _ARRPROSES) {
				try {
					setSessionaktif(false);
					setProcessingprogress(vProses.caption_target);
					const response = await fetch(vProses.url_target, {
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});

					console.log(`(Tutupperiode - apiProsesEOMSekuensial) processSequentially ${vProses.caption_target} == ${UFunc.JamMenitDetik()}`)
					if (!response.ok) {
						throw new Error(`Failed to execute task at ${vProses.caption_target}`);
					}

					setSessionaktif(true);
					const output_string = await response.json();
					if (output_string.errors) {
						throw new Error(`${vProses.caption_target} [ERRORS]: ${output_string.errors}`);
					}
					if (output_string.info) {
						throw new Error(`${vProses.caption_target} [INFO]: ${output_string.info}`);
					}
					if(output_string.expired) {
						prosesExpired();
						throw new Error("{EXPIRED SESSION}");
					}

					vArrResults.push(output_string.sukses); // Add successful vArrResults
					if(output_string.reprocess) {
						const resultreprocess = await reprocessApi(vProses);
					}
				} catch (err) {
					console.log(`(Tutupperiode - apiProsesEOMSekuensial) processSequentially CATCH ${vProses.caption_target}: ${err.message} == ${UFunc.JamMenitDetik()}`);
			        throw err;
				}
			}
			return vArrResults;
		}

		(async () => {
			let vArrResults = [];
			const vElbuttoneod 	= document.getElementById("btnProsesEOD");
			const vElbutton 	= document.getElementById("btnProses");
			vElbutton && (vElbutton.disabled = true);
			vElbuttoneod && (vElbuttoneod.disabled = true);
			setProcessingtutup(true);
			setLoading(true);
			try {
				setProcessingprogress("Preparing");
				console.log(`(Tutupperiode - apiProsesEOMSekuensial) TRY ${UFunc.JamMenitDetik()}`)
				//--PREPARING--/
				setSessionaktif(false);
				const response = await fetch(pjson.homepage+"api/api_tutupperiode/pr_tutup_preparing", {
					headers: { Accept: "application/json", "Content-Type": "application/json" },
					method: "POST", mode: "cors",
					cache: "default",
					body: vDATAS,
				});
				const output_string = await response.json();
				setSessionaktif(true);
				if (output_string.errors) {
					throw new Error(`Preparing Proses [ERRORS]: ${output_string.errors}`);
				}
				if (output_string.info) {
					throw new Error(`Preparing Proses [INFO]: ${output_string.info}`);
				}
				if(output_string.expired) {
					prosesExpired();
					throw new Error("{EXPIRED SESSION}");
				}
				//--END PREPARING--/
				
				try {
					const results = await processSequentially(vArrprocess);
					vArrResults.push(...results);
				} finally {
					setProcessingprogress("Finishing");
					const response = await fetch(pjson.homepage+"api/api_tutupperiode/pr_finishing", {
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});
					const output_string = await response.json();
					uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||JSON.stringify(uSettingsystemObj))});
				}
			} catch (err) {
				//showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
				console.log(`(Tutupperiode - apiProsesEOMSekuensial) CATCH ${err.message} ${UFunc.JamMenitDetik()}`)
				showToast(err.message || 'An unexpected error occurred',"ERROR");
			} finally {
				vElbutton && (vElbutton.disabled = false);
				vElbuttoneod && (vElbuttoneod.disabled = false);

				console.log(`(Tutupperiode - apiProsesEOMSekuensial) FINALLY ${UFunc.JamMenitDetik()}`);
				setProcessingprogress("");
				setLoading(false);
				setProcessingtutup(false);

				if(vArrResults.length === vArrprocess.length) {
					showToast("<b>BERHASIL</b> !"+
						"<br/>Proses EOM Telah Selesai."+
						"<br/><br/><b>Silahkan Login Kembali Untuk Proses Selanjutnya</b>.."+
						"","SUKSES");
			    	clearStorage();
					setToken("");
				}
			}
		})();
	}
	const apiProsesEOM = () => {
		const vArrprocess	= [
			{ caption_target:"Proses EOM", url_target:pjson.homepage+"api/api_tutupperiode/pr_tutup_eom" },
		];

		const vDATAS	= JSON.stringify({
			send_parsdata : JSON.stringify(uDatamainObj),
			send_tokenauth : uTokenObj.userinit
		});

		const processSequentially = async(_ARRPROSES) => {
			let vArrResults = [];

			for (const vProses of _ARRPROSES) {
				try {
					setSessionaktif(false);
					setProcessingprogress(vProses.caption_target);
					const response = await fetch(vProses.url_target, {
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});

					console.log(`(Tutupperiode - apiProsesEOM) processSequentially ${vProses.caption_target} == ${UFunc.JamMenitDetik()}`)
					if (!response.ok) {
						throw new Error(`Failed to execute task at ${vProses.caption_target}`);
					}

					setSessionaktif(true);
					const output_string = await response.json();
					if (output_string.errors) {
						throw new Error(`${vProses.caption_target} [ERRORS]: ${output_string.errors}`);
					}
					if (output_string.info) {
						throw new Error(`${vProses.caption_target} [INFO]: ${output_string.info}`);
					}
					if(output_string.expired) {
						prosesExpired();
						throw new Error("{EXPIRED SESSION}");
					}

					vArrResults.push(output_string.sukses); // Add successful vArrResults
				} catch (err) {
					console.log(`(Tutupperiode - apiProsesEOM) processSequentially CATCH ${vProses.caption_target}: ${err.message} == ${UFunc.JamMenitDetik()}`);
			        throw err;
				}
			}
			return vArrResults;
		}

		(async () => {
			let vArrResults = [];
			const vElbuttoneod 	= document.getElementById("btnProsesEOD");
			const vElbutton 	= document.getElementById("btnProses");

			vElbutton && (vElbutton.disabled = true);
			vElbuttoneod && (vElbuttoneod.disabled = true);
			setProcessingtutup(true);
			setLoading(true);
			try {
				setProcessingprogress("Preparing");
				console.log(`(Tutupperiode - apiProsesEOM) TRY ${UFunc.JamMenitDetik()}`);
				//--PREPARING--/
				setSessionaktif(false);
				const response = await fetch(pjson.homepage+"api/api_tutupperiode/pr_tutup_preparing", {
					headers: { Accept: "application/json", "Content-Type": "application/json" },
					method: "POST", mode: "cors",
					cache: "default",
					body: vDATAS,
				});
				const output_string = await response.json();
				setSessionaktif(true);
				if (output_string.errors) {
					throw new Error(`Preparing Proses [ERRORS]: ${output_string.errors}`);
				}
				if (output_string.info) {
					throw new Error(`Preparing Proses [INFO]: ${output_string.info}`);
				}
				if(output_string.expired) {
					prosesExpired();
					throw new Error("{EXPIRED SESSION}");
				}
				//--END PREPARING--/
				
				try {
					const results = await processSequentially(vArrprocess);
					vArrResults.push(...results);
				} finally {
					setProcessingprogress("Finishing");
					const response = await fetch(pjson.homepage+"api/api_tutupperiode/pr_finishing/tidak",{
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});
					const output_string = await response.json();

					/*//--SEMENTARA_TEST--/
					console.log(`(Tutupperiode - apiProsesEOM) FINALLY ${vArrResults.length} === ${vArrprocess.length}`);
					console.log(`(Tutupperiode - apiProsesEOM) FINALLY output_string => ${JSON.stringify(output_string)}`);

					if (output_string.errors) {
						console.log(`(Tutupperiode - apiProsesEOM) output_string.errors => ${output_string.errors} ${UFunc.JamMenitDetik()}`);
						//showToast(output_string.errors || 'Custom Error from Server',"ERROR");
						return;
					}
					if(output_string.info) {
						console.log(`(Tutupperiode - apiProsesEOM) output_string.info => ${output_string.info} ${UFunc.JamMenitDetik()}`);
						//showToast(output_string.info || 'Custom INFO from Server',"ERROR");
						return;
					}
					if(output_string.expired) {
						prosesExpired();
						return;
					}
					//--END SEMENTARA_TEST--*/
					uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||JSON.stringify(uSettingsystemObj))});
				}
			} catch (err) {
				//showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
				console.log(`(Tutupperiode - apiProsesEOM) CATCH ${err.message} ${UFunc.JamMenitDetik()}`)
				showToast(err.message || 'An unexpected error occurred',"ERROR");
			} finally {
				vElbutton && (vElbutton.disabled = false);
				vElbuttoneod && (vElbuttoneod.disabled = false);

				console.log(`(Tutupperiode - apiProsesEOM) FINALLY ${UFunc.JamMenitDetik()}`)
				setProcessingprogress("");
				setLoading(false);
				setProcessingtutup(false);

				if(vArrResults.length === vArrprocess.length) {
					showToast("<b>BERHASIL</b> !"+
						"<br/>Proses EOM Telah Selesai."+
						"<br/><br/><b>Silahkan Login Kembali Untuk Proses Selanjutnya</b>.."+
						"","SUKSES");
			    	clearStorage();
					setToken("");
				}
			}
		})();
	}
	const apiProsesEOY = () => {
		const vArrprocess	= [
			{ caption_target:"Proses EOY", url_target:pjson.homepage+"api/api_tutupperiode/pr_tutup_eoy" },
		];

		const vDATAS	= JSON.stringify({
			send_parsdata : JSON.stringify({...uDatamainObj,
				nilai_pph2529: parseFloat(uDlgformObj.nilai_pph2529),
			}),
			send_tokenauth : uTokenObj.userinit
		});

		const processSequentially = async(_ARRPROSES) => {
			let vArrResults = [];

			for (const vProses of _ARRPROSES) {
				try {
					setSessionaktif(false);
					setProcessingprogress(vProses.caption_target);
					const response = await fetch(vProses.url_target, {
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});

					console.log(`(Tutupperiode - apiProsesEOY) processSequentially ${vProses.caption_target} == ${UFunc.JamMenitDetik()}`)
					if (!response.ok) {
						throw new Error(`Failed to execute task at ${vProses.caption_target}`);
					}

					setSessionaktif(true);
					const output_string = await response.json();
					if (output_string.errors) {
						throw new Error(`${vProses.caption_target} [ERRORS]: ${output_string.errors}`);
					}
					if (output_string.info) {
						throw new Error(`${vProses.caption_target} [INFO]: ${output_string.info}`);
					}
					if(output_string.expired) {
						prosesExpired();
						throw new Error("{EXPIRED SESSION}");
					}

					vArrResults.push(output_string.sukses); // Add successful vArrResults
				} catch (err) {
					console.log(`(Tutupperiode - apiProsesEOY) processSequentially CATCH ${vProses.caption_target}: ${err.message} == ${UFunc.JamMenitDetik()}`);
			        throw err;
				}
			}
			return vArrResults;
		}

		(async () => {
			let vArrResults = [];
			const vElbuttoneod 	= document.getElementById("btnProsesEOD");
			const vElbutton 	= document.getElementById("btnProses");

			vElbutton && (vElbutton.disabled = true);
			vElbuttoneod && (vElbuttoneod.disabled = true);
			setProcessingtutup(true);
			setLoading(true);
			try {
				setProcessingprogress("Preparing");
				console.log(`(Tutupperiode - apiProsesEOY) TRY ${UFunc.JamMenitDetik()}`)
				//--PREPARING--/
				setSessionaktif(false);
				const response = await fetch(pjson.homepage+"api/api_tutupperiode/pr_tutup_preparing", {
					headers: { Accept: "application/json", "Content-Type": "application/json" },
					method: "POST", mode: "cors",
					cache: "default",
					body: vDATAS,
				});
				const output_string = await response.json();
				setSessionaktif(true);
				if (output_string.errors) {
					throw new Error(`Preparing Proses [ERRORS]: ${output_string.errors}`);
				}
				if (output_string.info) {
					throw new Error(`Preparing Proses [INFO]: ${output_string.info}`);
				}
				if(output_string.expired) {
					prosesExpired();
					throw new Error("{EXPIRED SESSION}");
				}
				//--END PREPARING--/
				
				try {
					const results = await processSequentially(vArrprocess);
					vArrResults.push(...results);
				} finally {
					setProcessingprogress("Finishing");
					const response = await fetch(pjson.homepage+"api/api_tutupperiode/pr_finishing/tidak",{
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});
					const output_string = await response.json();
					uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||JSON.stringify(uSettingsystemObj))});
				}
			} catch (err) {
				//showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
				console.log(`(Tutupperiode - apiProsesEOY) CATCH ${err.message} ${UFunc.JamMenitDetik()}`)
				showToast(err.message || 'An unexpected error occurred',"ERROR");
			} finally {
				vElbutton && (vElbutton.disabled = false);
				vElbuttoneod && (vElbuttoneod.disabled = false);

				console.log(`(Tutupperiode - apiProsesEOY) FINALLY ${UFunc.JamMenitDetik()}`)
				setProcessingprogress("");
				setLoading(false);
				setProcessingtutup(false);

				if(vArrResults.length === vArrprocess.length) {
					showToast("<b>BERHASIL</b> !"+
						"<br/>Proses EOY Telah Selesai."+
						"<br/><br/><b>Silahkan Login Kembali Untuk Proses Selanjutnya</b>.."+
						"","SUKSES");
			    	clearStorage();
					setToken("");
				}
			}
		})();
	}

	const _apiProsestutup_ = () => {//--DIGANTI_JADI_SEQUENTIALLY--/
		const vElbutton 	= document.getElementById("btnProses");
		const vElbuttoneod 	= document.getElementById("btnProsesEOD");
		vElbutton && (vElbutton.disabled = true);
		vElbuttoneod && (vElbuttoneod.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout); setLoading(false);
			vElbutton && (vElbutton.disabled = false);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_parsdata : JSON.stringify(uDatamainObj),
			send_nilaipph2529: parseFloat(uDlgformObj.nilai_pph2529)||0,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_tutupperiode/pr_tutup";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			vElbutton && (vElbutton.disabled = false);
			vElbuttoneod && (vElbuttoneod.disabled = false);
			setLoading(false);
			//console.log("(Tutupperiode - apiProsestutup) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.sukses) {
				//setDatamainObj(JSON.parse(output_string.dataobjectnew || "{}"));
				//uDispatch({type: "set", gIsEOMExecuted: ((output_string.status_eom||"TIDAK")==="YA")});
				setSessionaktif(false);
				showToast("<b>BERHASIL</b> !"+
					"<br/>Tutup Periode Telah Selesai."+
					"<br/><br/><b>Silahkan Login Kembali Untuk Proses Selanjutnya</b>.."+
					"","SUKSES");
		    	clearStorage();
				setToken("");
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Tutupperiode - apiProsestutup) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			const vTimeEnd 	= new Date();
			const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			//vElbutton && (vElbutton.disabled = false);
			//vElbuttoneod && (vElbuttoneod.disabled = false);
			setLoading(false);
			console.log("(Tutupperiode - apiProsestutup) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");

			if(vTimeDiff > 30000) 
				{ clearStorage(); setToken(""); }
		});
	}
	const _apiProsesEOD_OLD = () => {//--DIGANTI_JADI_SEQUENTIALLY--/
		const vElbuttoneod 	= document.getElementById("btnProsesEOD");
		const vElbutton 	= document.getElementById("btnProses");
		vElbutton && (vElbutton.disabled = true);
		vElbuttoneod && (vElbuttoneod.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
			vElbutton && (vElbutton.disabled = false);

			showToast("<b>BERHASIL</b> !"+
				"<br/>Proses EOD Telah Selesai."+
				"<br/><br/><b>Silahkan Lanjutkan Aktifitas Selanjutnya</b>.."+
				"","SUKSES");
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_parsdata : JSON.stringify(uDatamainObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_tutupperiode/pr_eod";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			vElbutton && (vElbutton.disabled = false);
			vElbuttoneod && (vElbuttoneod.disabled = false);
			setLoading(false);
			//console.log("(Tutupperiode - apiProsesEOD) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.sukses) {
				uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||JSON.stringify(uSettingsystemObj))});
				showToast("<b>BERHASIL</b> !"+
					"<br/>Proses EOD Telah Selesai."+
					"<br/><br/>Mohon Logout dan Login Kembali, dan <b>Silahkan Lanjutkan Aktifitas Selanjutnya</b>.."+
					"","SUKSES");
		    	clearStorage();
				setToken("");
			} else {
				setSessionaktif(true);
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Tutupperiode - apiProsesEOD) output_string.errors : "+output_string.errors);
					const vMsg 	= (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}
			}
		})
		.catch((error) =>{
			const vTimeEnd 	= new Date();
			const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			//vElbutton && (vElbutton.disabled = false);
			//vElbuttoneod && (vElbuttoneod.disabled = false);
			setLoading(false);
			console.log("(Tutupperiode - apiProsesEOD) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");

			if(vTimeDiff > 30000) 
				{ clearStorage(); setToken(""); }
		});
	}
	const apiProsesbatalstatus = () => {
		const vElbuttoneod 	= document.getElementById("btnProsesEOD");
		const vElbuttoneom 	= document.getElementById("btnProses");
		const vElbutton 	= document.getElementById("btnBatalflageom");
		vElbutton && (vElbutton.disabled = true);
		vElbuttoneom && (vElbuttoneom.disabled = true);
		vElbuttoneod && (vElbuttoneod.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
			vElbuttoneod && (vElbuttoneod.disabled = false);
			vElbuttoneom && (vElbuttoneom.disabled = false);
			vElbutton && (vElbutton.disabled = false);

			uDatamainObj.eom_is_running	= "TIDAK";
			showToast("<b>BERHASIL</b> !"+
				"<br/>Proses Pembatalan Status Telah Selesai."+
				"<br/><br/><b>Silahkan Lanjutkan Aktifitas Selanjutnya</b>.."+
				"","SUKSES");
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_tutupperiode/pr_batalstatus";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			//console.log("(Tutupperiode - apiProsesEOD) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.sukses) {
				vElbuttoneom && (vElbuttoneom.disabled = false);
				vElbuttoneod && (vElbuttoneod.disabled = false);
				uDatamainObj.eom_is_running	= "TIDAK";
				showToast("<b>BERHASIL</b> !"+
					"<br/>Proses Pembatalan Status Telah Selesai."+
					"<br/><br/><b>Silahkan Lanjutkan Aktifitas Selanjutnya</b>.."+
					"","SUKSES");
			} else {
				setSessionaktif(true);
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Tutupperiode - apiProsesbatalstatus) output_string.errors : "+output_string.errors);
					const vMsg 	= (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}
			}
		})
		.catch((error) =>{
			vElbutton && (vElbutton.disabled = false);
			//vElbuttoneom && (vElbuttoneom.disabled = false);
			//vElbuttoneod && (vElbuttoneod.disabled = false);
			setLoading(false);

			console.log("(Tutupperiode - apiProsesbatalstatus) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END API--/

	/*React.useEffect(()=>{
		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		}
	})//-*/
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

	   const handleConnectionChange = () => {
	      if (navigator.connection) {
	        setConnectionType(navigator.connection.effectiveType);
	      } else {
	        setConnectionType('Unknown');
	      }
	    };

	    // Initial check
	    handleConnectionChange();

	    // Listen for changes
	    navigator.connection.addEventListener('change', handleConnectionChange);//-*/

		apiLoaddata();

		return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDatamainObj({});
			setProcessingtutup(false);
			setDlgformshow(false);
     		navigator.connection.removeEventListener('change', handleConnectionChange);
		}
	},[])
	React.useEffect(()=>{
		if(!uISProcessingtutup) {
			return;
		}

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		}
	},[uISProcessingtutup])
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderactionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderactionObj});

		apiLoaddata();
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uISDlgformshow) { 
			document.getElementById("btnProses") && 
				(document.getElementById("btnProses").disabled = false);
		
			setDlgformObj({});
			return 
		}

		document.getElementById("btnProses") && 
			(document.getElementById("btnProses").disabled = true);
		
		let vTimeout = setTimeout(()=>{
			const vElfocus = document.getElementById("inpnilaipph2529");

			if(!isMobile)
				vElfocus && vElfocus.focus();
		},350)
	},[uISDlgformshow]);

	//console.log("Tutupperiode - uIsEOMExecuted => "+(uIsEOMExecuted));

	if(UFunc.isEmpty(uTokenObj)) { setLoading(true); prosesExpired(); return (<></>); }
	if(uHTMLError500) return ( <MyPage500 content={uHTMLError500}/> )//>

	/*if(uTokenObj.userhak !== "FREEROLE") return (
		<CCard className="classcardbg mb-3">
			<CCardHeader className="">Forbidden</CCardHeader>
			<CCardBody className="px-md-5">
			<div className="mx-lg-5">
			<p className="fw-bolder">Maaf,</p>
			<p>Fitur ini hanya AVAILABLE bagi user {uBahasaObj.hakuser_freerole}.
				<br/>Agar Aplikasi/Sistem Ini dapat berjalan Kembali, Mohon Hubungi {uBahasaObj.hakuser_freerole} Anda, untuk melakukan Proses Tutup Buku..</p>
			<p className="fst-italic">Terimakasih,</p>
			</div>
			</CCardBody>
		</CCard>
	)//>//-*/

	return (
	<>
		{uISProcessingtutup && (
			<CBadge className="position-fixed fst-italic classblinking py-2 text-center"
				color="danger"
				style={{zIndex:1092,top:"50%",left:"50%",transform:"translate(-50%,30px)"}}>
				<p>Mohon Ditunggu,
				<br/>JANGAN TUTUP BROWSER ANDA...</p>
				<small className="text-uppercase text-warning">
					&middot;&middot;{uProcessingprogress}&middot;&middot;
				</small>
			</CBadge>
		)}

		<CRow className="align-items-stretch mb-3">
		<CCol md="6" className="">
		<CCard className="classcardbg h-100">
			<CCardHeader className="">Tutup Periode Sebelumnya</CCardHeader>
			<CCardBody className="">{contentData()}</CCardBody>
		</CCard>
		</CCol>

		<CCol className="" style={{display:"flex",flexDirection:"column"}}>
		<CCard className="classcardbg mb-3 mt-3 mt-md-0">
			<CCardHeader className="">End Of Days</CCardHeader>
			<CCardBody className="">{contentFormeod()}</CCardBody>
		</CCard>

		<CCard className="classcardbg" style={{flex: "1 0 0"}}>
			<CCardHeader className="fw-bolder">Proses EOM / EOY</CCardHeader>
			<CCardBody className="">{contentFormtutup()}</CCardBody>
		</CCard>
		</CCol>
		</CRow>

		<MyDialogform
			options={{centered:true}}
			onSimpan={()=>hdlKlikDlgformsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>
	</>
	)//>
}	

export default Tutupperiode